var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/dashboard-grid.tsx
import { cn } from "@repo/utils";
function DashboardGrid({ children, className }) {
  return /* @__PURE__ */ React.createElement("div", {
    className: cn("grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4", className)
  }, children);
}
__name(DashboardGrid, "DashboardGrid");

// src/dashboard-stat-card.tsx
import { cn as cn2 } from "@repo/utils";
var trendColors = {
  up: "text-success-text",
  down: "text-danger-text",
  flat: "text-text-muted"
};
var trendArrows = {
  up: "\u2191",
  down: "\u2193",
  flat: "\u2192"
};
function SkeletonBlock({ className }) {
  return /* @__PURE__ */ React.createElement("div", {
    className: cn2("bg-surface-2 rounded-[6px] relative overflow-hidden", "after:absolute after:inset-0 after:bg-gradient-to-r after:from-transparent after:via-surface-3 after:to-transparent after:translate-x-[-100%]", "[&::after]:[animation:skeleton-shimmer_1.5s_ease-in-out_infinite]", className)
  });
}
__name(SkeletonBlock, "SkeletonBlock");
function DashboardStatCard({ title, value, icon, isLoading, isError, trend, onClick, className }) {
  if (isLoading) {
    return /* @__PURE__ */ React.createElement("div", {
      className: cn2("bg-surface-1 rounded-[10px] p-6 flex flex-col gap-3 shadow-sm", className)
    }, /* @__PURE__ */ React.createElement(SkeletonBlock, {
      className: "h-3 w-20"
    }), /* @__PURE__ */ React.createElement(SkeletonBlock, {
      className: "h-8 w-32"
    }), /* @__PURE__ */ React.createElement(SkeletonBlock, {
      className: "h-3 w-24"
    }));
  }
  if (isError) {
    return /* @__PURE__ */ React.createElement("div", {
      className: cn2("bg-surface-1 rounded-[10px] p-6 flex flex-col items-center justify-center gap-2 text-center shadow-sm", className)
    }, /* @__PURE__ */ React.createElement("div", {
      className: "text-danger-500"
    }, /* @__PURE__ */ React.createElement("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, /* @__PURE__ */ React.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "10"
    }), /* @__PURE__ */ React.createElement("line", {
      x1: "12",
      y1: "8",
      x2: "12",
      y2: "12"
    }), /* @__PURE__ */ React.createElement("line", {
      x1: "12",
      y1: "16",
      x2: "12.01",
      y2: "16"
    }))), /* @__PURE__ */ React.createElement("p", {
      className: "text-xs text-text-muted"
    }, "Failed to load"));
  }
  return /* @__PURE__ */ React.createElement("div", {
    onClick,
    className: cn2("bg-surface-1 rounded-[10px] p-6 flex flex-col gap-2 shadow-sm", onClick && "cursor-pointer hover:bg-surface-2 transition-colors", className)
  }, /* @__PURE__ */ React.createElement("div", {
    className: "flex items-center justify-between"
  }, /* @__PURE__ */ React.createElement("span", {
    className: "text-xs font-medium text-text-secondary uppercase tracking-wide"
  }, title), icon && /* @__PURE__ */ React.createElement("span", {
    className: "text-text-muted"
  }, icon)), /* @__PURE__ */ React.createElement("div", {
    className: "text-2xl font-semibold text-text-primary tnum leading-tight"
  }, value), trend && /* @__PURE__ */ React.createElement("span", {
    className: cn2("text-xs font-medium", trendColors[trend.direction])
  }, trendArrows[trend.direction], " ", trend.label));
}
__name(DashboardStatCard, "DashboardStatCard");

// src/dashboard-section.tsx
import { cn as cn3 } from "@repo/utils";
function DashboardSection({ title, action, children, className }) {
  return /* @__PURE__ */ React.createElement("div", {
    className: cn3("bg-surface-1 border border-border rounded-[10px] overflow-hidden", className)
  }, (title || action) && /* @__PURE__ */ React.createElement("div", {
    className: "flex items-center justify-between px-5 py-4 border-b border-border"
  }, title && /* @__PURE__ */ React.createElement("h3", {
    className: "text-sm font-semibold text-text-primary"
  }, title), action && /* @__PURE__ */ React.createElement("div", {
    className: "flex-shrink-0"
  }, action)), /* @__PURE__ */ React.createElement("div", {
    className: "p-5"
  }, children));
}
__name(DashboardSection, "DashboardSection");

// src/dashboard-period-selector.tsx
import React2 from "react";
import { cn as cn4 } from "@repo/utils";
var defaultOptions = [
  "today",
  "week",
  "month",
  "quarter",
  "year"
];
var labels = {
  today: "Today",
  week: "Week",
  month: "Month",
  quarter: "Quarter",
  year: "Year"
};
function DashboardPeriodSelector({ period, onChange, options = defaultOptions }) {
  return /* @__PURE__ */ React2.createElement("div", {
    className: "flex items-center gap-1 bg-surface-2 rounded-[8px] p-1 border border-border w-fit"
  }, options.map((opt) => /* @__PURE__ */ React2.createElement("button", {
    key: opt,
    onClick: /* @__PURE__ */ __name(() => onChange(opt), "onClick"),
    className: cn4("px-3 py-1.5 text-xs font-medium rounded-[6px] transition-colors", period === opt ? "bg-surface-1 text-text-primary shadow-sm border border-border" : "text-text-muted hover:text-text-secondary")
  }, labels[opt])));
}
__name(DashboardPeriodSelector, "DashboardPeriodSelector");
export {
  DashboardGrid,
  DashboardPeriodSelector,
  DashboardSection,
  DashboardStatCard
};
//# sourceMappingURL=index.js.map